import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { HorizontalHouseAd } from './HorizontalHouseAd';
import { LINK_TYPES } from './constants';
import { TemplateType } from './types';

import { Box } from '@mui/material';
import { env } from '@repo/env';
import React from 'react';
import { StructuredContentRenderer } from '../..';

export const WPHouseAd = (doc: StructuredContentDocument) => {
  const environment = env.NEXT_PUBLIC_DEPLOYABLE_ENV;
  if (!doc.props.body) {
    if (environment === 'stage' || environment === 'dev') {
      console.warn(
        `WPHouseAd Structured Content Renderer missing content for doc id: ${doc.props.id}`,
      );
    }
    return null;
  }

  const { headline, body, ctaAuthLink, ctaText, ctaType, ctaUrl, featuredMedia, template } =
    doc.props;

  const ctaProps =
    ctaType === LINK_TYPES.AUTH
      ? {
          ctaNode: ctaAuthLink && <StructuredContentRenderer doc={ctaAuthLink} />,
        }
      : { ctaHref: ctaUrl };

  const houseAdProps = {
    headline,
    body,
    ...ctaProps,
    ctaText,
    featuredMedia,
  };

  let houseAd: React.JSX.Element;

  // Add new templates here if needed
  switch (template) {
    case TemplateType.HORIZONTAL:
    default:
      houseAd = <HorizontalHouseAd {...houseAdProps} />;
  }

  return <Box>{houseAd}</Box>;
};
